var path = '/app/pages/stage-sixth/stage-sixth.html';
var html = "<stage-book-quiz class=fill questions=$ctrl.questions forms=$ctrl.forms title={{$ctrl.title}} on-success=$ctrl.onSuccess()></stage-book-quiz>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/stage-sixth/stage-sixth.html
// module id = 272
// module chunks = 0